export default function Style(){
  return (
    <style>
      {`
       .fontWeight {
  font-weight: 400px;
  line-height: 30px;
}

.btn {
  font-weight: 600 !important;
  font-family: 'Josefin Sans' !important;
  color: #010101;
  letter-spacing: 1px;
  background-color: #FCBD00 !important;
  font-size: 18px;
  padding: 14px 30px;
}

Link {
  cursor: pointer !important;
}



@media screen and (max-width: 1200px) and (min-width: 990px) {

  .box-height {
    min-height: 80px !important;
  }
}

.box-height {
  min-height: 80px !important;
}

@media (max-width: 1533px) {
  .fs-p-varies {
    font-size: 22px !important;
    line-height: 28px !important;
    font-weight: 400 !important;
  }

  .fs-18-27 {
    font-size: 16px !important;
    line-height: 24px !important;
    font-weight: 400 !important;
  }

  .fs-24-30 {
    font-size: 22px !important;
    line-height: 28px !important;
  }

}

@media (min-width: 1534px) {
  .fs-p-varies {
    font-size: 24px !important;
    line-height: 30px !important;
    font-weight: 400 !important;
  }

  .fs-18-27 {
    font-size: 18px !important;
    line-height: 27px !important;
    font-weight: 400 !important;
  }

  .fs-24-30 {
    font-size: 24px !important;
    line-height: 30px !important;
  }
}

        `}
    </style>
  );
}
